import type { GlobalSearchResultDto } from '@bhops/shared';
import { apiClient } from './client';

export const searchApi = {
  async search(q: string): Promise<GlobalSearchResultDto> {
    const { data } = await apiClient.get<GlobalSearchResultDto>('/search', {
      params: { q },
    });
    return data;
  },
};
